export const EMPTY_SALES_CHANNEL = {
  attributes: {
    name: '',
  },
}
